module.exports = __webpack_public_path__ + "img/28-1-2023_raices_thumb.8850f134.jpeg";